var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_534_1554",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.485352,
    y: 0.801071,
    width: 23.6633,
    height: 23.6633,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_534_1554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.48578 21.7069C4.8649 21.7069 4.33583 21.4882 3.89857 21.051C3.46131 20.6137 3.24268 20.0846 3.24268 19.4638V5.80167C3.24268 5.18079 3.46131 4.65172 3.89857 4.21446C4.33583 3.77719 4.8649 3.55856 5.48578 3.55856H12.364V5.80167H5.48578V19.4638H12.364V21.7069H5.48578ZM16.1841 17.8455L14.6339 16.2331L17.1127 13.7543H9.31176V11.5112H17.1127L14.6339 9.03232L16.1841 7.41992L21.391 12.6327L16.1841 17.8455Z",
    fill: "#4E5154"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.4439d259f2f91e74275cfe201d5fe5c1.svg";
export { ForwardRef as ReactComponent };